// CarCards.tsx
import React, { useState } from 'react';
import './ClassifiedCarCards.scss';
import { Pagination } from 'antd';
import { toggleFavorite } from '../../utils/toggleFavorites';
import { Car } from '../../types/home';
import { useNavigate } from 'react-router-dom';
import ClassifiedCarCard from './ClassifiedCarCard';

interface CarCardProps {
    page: number;
    itemsPerPage: number;
    dataSource: Array<Car>;
    carsLength: number;
    onPageChange: (page: number) => void;
    setDataSource: (cars: Array<Car>) => void;
    starToggle: string;
    setStarChanged: (starChanged: boolean) => void;
    onNavigateToDetails: () => void;
    pages: boolean; // Determines if pagination should be shown
}

const ClassifiedCarCards: React.FC<CarCardProps> = ({
    page,
    itemsPerPage,
    dataSource,
    carsLength,
    onPageChange,
    setDataSource,
    starToggle,
    setStarChanged,
    onNavigateToDetails,
    pages // Destructure the 'pages' prop
}) => {
    const [currentPage, setCurrentPage] = useState(page);
    const navigate = useNavigate();

    const handleTableChange = (pagination: number) => { // Changed type to number for clarity
        setCurrentPage(pagination);
        onPageChange(pagination); // Notify parent component of page change
    };

    const toggleStar = (name: string) => {
        const updatedDataSource = dataSource.map((car) => {
            if (car.name === name) {
                toggleFavorite({ link: car.link, favorited: !car.Favorited });
                return { ...car, Favorited: !car.Favorited }; // Toggle Favorited
            }
            return car;
        });
        if (starToggle === "starred") {
            setStarChanged(true);
        }
        setDataSource(updatedDataSource); // Update the dataSource state
    };

    return (
        <div className="car-cards-container">
            {dataSource.map((car) => (
                <ClassifiedCarCard
                    key={car.key}
                    car={car}
                    toggleStar={toggleStar}
                    onNavigateToDetails={onNavigateToDetails}
                />
            ))}

            {/* Conditionally render Pagination if 'pages' is true */}
            {pages && (
                <Pagination
                    className="custom-pagination"
                    current={page}
                    pageSize={itemsPerPage}
                    total={carsLength}
                    onChange={handleTableChange}
                    showSizeChanger={false}
                />
            )}
        </div>
    );
};

export default ClassifiedCarCards;
